import React, { useState, useEffect } from 'react';
import { useDispatch } from "react-redux";
import Form, { ButtonItem, ButtonOptions, GroupItem, Item, Label, RequiredRule, CheckBox } from "devextreme-react/form";
import Request from "../../components/Request/Request";
//import * as AppActions from '../../../actions/AppActions';
import { ToastType } from "../../constants/Constants";
import { showToast, parseDate, hasRole } from "../../utils/Utils";
import * as AppActions from '../../actions/AppActions';

const GostergeDetay = (props) => {

    const dispatch = useDispatch();

    const [data, setData] = useState();

    const [storeGostergeTipi, setStoreGostergeTipi] = useState([]);

    useEffect(() => {
        getData();
        setStoreGostergeTipi([
            {id:'UST_GOSTERGE' , name:'Üst Gösterge'},
            {id:'ALT_GOSTERGE' , name:'Alt Gösterge'}
        ])
    }, [])

    const getData = () => {

        let id = -1;
        if (props.data && props.data.id) {
            id = props.data.id;
        } else {
            setData({});
            return;
        }
        const request = new Request("/emeklilik-app/api/gosterge-tanim/getKayit/" + id, "GET");
        dispatch(AppActions.setLoading(true, "Kayıt yükleniyor.."));
        return request.run()
            .then(response => {
                dispatch(AppActions.setLoading(false, ""));
                setData(response.data.data);
            });
    }
    function kaydet(e) {

        let eksikBilgi = false;
        e.validationGroup.validators.map((a) => {
            if (a.validate().status !== "valid") {
                eksikBilgi = true;
            }
        }
        );
        if (eksikBilgi) {
            showToast('Zorunlu alanları kontrol ediniz', ToastType.ERROR, 500);
            return;
        }

        let formData = data;

        let method = "POST"
        let url = "/emeklilik-app/api/gosterge-tanim/save";

        const request = new Request(url, method, formData);
        dispatch(AppActions.setLoading(true, "Kayıt işlemi yapılıyor.."));
        return request.run()
            .then(response => {
                dispatch(AppActions.setLoading(false, ""));
                if (response.data && response.data.data) {
                    props.hide();
                }
            });


    }


    return (
        <div >
            <Form formData={data} colCount={1} id="form" labelLocation={"left"} className="option" >

                <Item disabled={false} dataField={'yil'} editorType={'dxNumberBox'} editorOptions={{ showSpinButtons: true, showClearButton: false, min: 1, max: 10 }}>
                    <RequiredRule message="Yıl bilgisi gerekli" />
                    <Label text='Yıl' />
                </Item>
                <Item disabled={false} dataField={'gostergeTipi'} editorType={'dxSelectBox'}
                    editorOptions={{ 
                         dataSource: storeGostergeTipi,
                         valueExpr: "id",
                         displayExpr: "name",
                         placeholder: "Select a value...",
                         //stylingMode: 'outlined',
                         }}>
                    <RequiredRule message="Gösterge Tipi bilgisi gerekli" />
                    <Label text='Gösterge Tipi' />
                </Item>
                <Item disabled={false} dataField={'altKazanc'} editorType={'dxNumberBox'} editorOptions={{ showSpinButtons: false, showClearButton: false }}>
                    <RequiredRule message="Alt Kazanç bilgisi gerekli" />
                    <Label text='Alt Kazanç' />
                </Item>
                <Item disabled={false} dataField={'ustKazanc'} editorType={'dxNumberBox'} editorOptions={{ showSpinButtons: false, showClearButton: false }}>
                    <RequiredRule message="Üst Kazanç bilgisi gerekli" />
                    <Label text='Üst Kazanç' />
                </Item>
                <Item disabled={false} dataField={'gostergeDeger'} editorType={'dxNumberBox'} editorOptions={{ showSpinButtons: false, showClearButton: false }}>
                    <RequiredRule message="Gösterge bilgisi gerekli" />
                    <Label text='Gösterge' />
                </Item>
                <Item disabled={false} dataField={'aboDeger'} editorType={'dxNumberBox'} editorOptions={{ showSpinButtons: false, showClearButton: false }}>
                    <RequiredRule message="Abo bilgisi gerekli" />
                    <Label text='Abo' />
                </Item>
                <Item disabled={false} dataField={'derece'} editorType={'dxNumberBox'} editorOptions={{ showSpinButtons: false, showClearButton: false }}>
                    <RequiredRule message="Derece bilgisi gerekli" />
                    <Label text='Derece' />
                </Item>
                <Item disabled={false} dataField={'kademe'} editorType={'dxNumberBox'} editorOptions={{ showSpinButtons: false, showClearButton: false }}>
                    <RequiredRule message="Kademe bilgisi gerekli" />
                    <Label text='Kademe' />
                </Item>


                <ButtonItem>
                    <ButtonOptions
                        onClick={(e) => { kaydet(e); }}
                        width={'100%'}
                        type={'success'}
                        useSubmitBehavior={true}>
                        <span className="dx-button-text">
                            {'Kaydet'
                            }
                        </span>
                    </ButtonOptions>
                </ButtonItem>

            </Form>


        </div>
    )
}

export default GostergeDetay;
